import { render, staticRenderFns } from "./ImportarTxtNephrosys.vue?vue&type=template&id=732689cc&"
import script from "./ImportarTxtNephrosys.vue?vue&type=script&lang=js&"
export * from "./ImportarTxtNephrosys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports